import React from "react";
import GoogleMapReact from "google-map-react";
import MapMarker from "../map-marker.jsx";
import { googleApiKey } from '../../../config.json';

const IntlMap = props => {
  const getMapOptions = maps => {
    return {
      disableDefaultUI: false,
      mapTypeControl: true,
      zoomControlOptions: {
        position: maps.ControlPosition.RIGHT_CENTER,
        style: maps.ZoomControlStyle.SMALL
      },
      mapTypeControlOptions: {
        position: maps.ControlPosition.TOP_LEFT
      }
    };
  };
  let zoom = 2.5;
  let center;
    
    if (props.country === '' && props.firstLoad) {
        center = props.center;
    }

    if (props.markers.length) {
        zoom = 4.5;
    }

    let count = 1;
    let distCount = 1;
  let emptyMarkers = [];

  let markers = props.markers.map((dealer, index) => {
      if (dealer.latitude !== 0 || dealer.longitude !== 0) {
          const dLat = parseFloat(dealer.latitude);
          const dLng = parseFloat(dealer.longitude);
        if (count === 1) {
            center = {
                lat: dLat,
                lng: dLng
            }
        }
    
      return (
        <MapMarker
              lat={dLat}
              lng={dLng}
              text={count++}
              dist={false}
        />
      );
    } else {
      return emptyMarkers;
    }
  });
    const distPins = props.distPins.map((item) => {
        const dLat = parseFloat(item.latitude);
        const dLng = parseFloat(item.longitude);
        if (dLat !== 0 || dLng !== 0) {
            if (count === 1) {
                center.lat = dLat;
                center.lng = dLng;
            }
            return (
                <MapMarker
                    lat={dLat}
                    lng={dLng}
                    text={distCount++}
                    dist={true}
                />
            );
        } else {
            center.lat = props.userLat;
            center.lng = props.userLng;
            return emptyMarkers;
        }
    });


  return (
    <div className="google-map">
      <GoogleMapReact
        bootstrapURLKeys={{ key: googleApiKey }}
        center={center}
        zoom={zoom}
        defaultZoom={zoom}
        options={getMapOptions}
        onChange={props._onChange}
      >
              {markers}
              {distPins}
      </GoogleMapReact>
    </div>
  );
};

export default IntlMap;
